<div class="">
  <div class="d-flex align-items-center gap-3 mb-3">
    <h6 class="mb-0" i18n>Payment Schedule</h6>
    <div class="flex-fill"></div>
    <div class="dropdown" dropdown>
      <button class="btn btn-secondary-primary dropdown-toggle" dropdownToggle type="button">
        <i class="fal fa-copy"></i>
        <ng-container i18n>Copy</ng-container>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
        <li>
          <button
            (click)="onCopyFrom()"
            matTooltip="Ability to copy schedules from rental/s to your selected rental"
            matTooltipPosition="left"
            i18n-matTooltip
          >
            <i class="fal fa-copy"></i> <ng-container i18n>Copy from Rental</ng-container>
          </button>
        </li>
        <li>
          <button
            (click)="onCopyTo()"
            matTooltip="Ability to copy schedules to rental from your selected rental/s"
            matTooltipPosition="left"
            i18n-matTooltip
          >
            <i class="fal fa-paste"></i> <ng-container i18n>Copy to Rental</ng-container>
          </button>
        </li>
      </ul>
    </div>
    <button (click)="onSave()" type="button" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-save"></span>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <div class="alert alert-secondary-info">
    <i class="fal fa-info-circle alert-icon"></i>
    <div class="alert-content" i18n>
      Setting up a payment schedule allows you to specify the payment amount you require from your traveler to confirm a
      booking. You can require 100% at the time of booking or set up multiple payments that can be scheduled for future
      dates.
    </div>
  </div>
  <div class="container-box p-3">
    <form [formGroup]="termsForm">
      <div formArrayName="terms" *ngFor="let item of terms.controls; let i = index">
        <div [formGroupName]="i" class="row term-box">
          <div *ngIf="hasDays(item['controls'].type.value)" class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="This indicates the day count of when the payment should be made w.r.t. payment time."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input type="number" formControlName="days" matInput required placeholder="Days" i18n-placeholder />
            </mat-form-field2>
          </div>
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="Choose when the payment should be made"
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="text"
                formControlName="typeView"
                matInput
                required
                placeholder="Payment time"
                i18n-placeholder
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="This indicates the % value of payment to be made."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input type="text" formControlName="percent" matInput required placeholder="Percent" i18n-placeholder />
            </mat-form-field2>
          </div>
          <div class="col-sm-1">
            <button
              (click)="onRemoveTerm(i)"
              class="btn btn-secondary-danger align-input-row-end"
              type="button"
              matTooltip="Remove"
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <i class="cs-icon cs-icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </form>

    <form
      *ngIf="canAddMoreTypes(terms.controls) && remainingPercentage?.length > 0 && remainingTypes?.length > 0"
      [formGroup]="termForm"
      class="no-bottom no-top"
    >
      <div class="row">
        <div *ngIf="hasDays(termForm.get('type').value)" class="col-sm-3">
          <mat-form-field2
            class="mat-block"
            matTooltip="This indicates the day count of when the payment should be made w.r.t. payment time."
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input type="number" formControlName="days" matInput required placeholder="Days" i18n-placeholder />
            <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('required')">
              <ng-container i18n>Days is required</ng-container>
            </mat-error>
            <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('min')">
              <ng-container i18n>Days must be positive number</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-3">
          <mat-form-field2>
            <mat-select
              matTooltip="Choose when the payment should be made"
              matTooltipPosition="above"
              i18n-matTooltip
              formControlName="type"
              placeholder="Payment time"
              i18n-placeholder
            >
              <mat-option *ngFor="let t of remainingTypes" [value]="t.value">
                {{ t.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="termForm.get('type').touched && termForm.get('type').hasError('required')">
              <ng-container i18n>Time is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-3">
          <mat-form-field2
            matTooltip="This indicates the % value of payment to be made."
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <mat-select formControlName="percent" placeholder="Percent" i18n-placeholder>
              <mat-option *ngFor="let t of remainingPercentage" [value]="t"> {{ t }} % </mat-option>
            </mat-select>
            <mat-error *ngIf="termForm.get('percent').touched && termForm.get('percent').hasError('required')">
              <ng-container i18n>Percent is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-1">
          <button
            (click)="onAddTerm(); $event.currentTarget.blur?.()"
            type="button"
            class="btn btn-secondary-info align-input-row-end"
            i18n
          >
            Add
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
